import { afterFrames } from '@/lib/animate';

import type { Editor } from '@tiptap/react';
import type { RefObject } from 'react';

/** Tracks selection drags from mouse, touch, and stylus. A drag that starts in the editor marks the user as selecting, moves re-check the bubble, and lifting clears the flag a few frames later so the final selection settles first. Returns the cleanup. */
export function trackSelectionPointerActivity(
  editor: Editor,
  isUserFocusedRef: RefObject<boolean>,
  updateVisibility: () => void
): () => void {
  let isSelecting = false;

  const handlePointerDown = (event: PointerEvent) => {
    const target = event.target as Node | null;
    const startedInEditor = Boolean(target && editor.view.dom.contains(target));

    if (startedInEditor) isUserFocusedRef.current = true;
    afterFrames(5, () => (isSelecting = startedInEditor));
  };

  const handlePointerUp = () => afterFrames(15, () => (isSelecting = false));

  const handlePointerMove = () => {
    if (!isSelecting) return;
    updateVisibility();
  };

  document.addEventListener('pointerdown', handlePointerDown);
  document.addEventListener('pointerup', handlePointerUp);
  document.addEventListener('pointercancel', handlePointerUp);
  document.addEventListener('pointermove', handlePointerMove);

  return () => {
    document.removeEventListener('pointerdown', handlePointerDown);
    document.removeEventListener('pointerup', handlePointerUp);
    document.removeEventListener('pointercancel', handlePointerUp);
    document.removeEventListener('pointermove', handlePointerMove);
  };
}
